<script lang='ts'>
    import { onMount } from 'svelte';
    import LibLoader from '../Util/LibLoader.svelte';
    import { type AddMarkerInterface, type MapController, type Polyline, iconEndMarker, iconStartMarker, noopMapController } from '@/Common/constants';
    import { cn } from '@/lib/utils';

    export let mapPolyline: Polyline = null
    let className: string = ''
    export { className as class }

    // TODO: This whole thing needs better typing.

    //@ts-expect-error
    const google = window.google

    let mapElement: HTMLElement
    let mapGroups: Record<string, { markers: Record<string, any>, lines: Record<string, any> }> = {
        "default": {
            markers: {},
            lines: {}
        }
    }
    let mapApi: any = null
    let fullBounds: any = null
    let zoomOverride = false

    function addHoverInfo(marker: any, label: string) { // TODO: Make a custom tooltip. InfoWindow is kinda of jarring.
        let infoWindow = new google.maps.InfoWindow({
                content: label
        });
        marker.content.addEventListener("mouseover", function () {
            infoWindow.open(mapApi.map, marker);
        });
        marker.content.addEventListener("mouseout", function () {
            infoWindow.close();
        });
    }

    function removeMarker(id: string, group = "default") {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        if (markers[id]) {
            markers[id].setMap(null);
            delete markers[id];
        }
    }

    function hideMarker(id: string, group = "default") {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        if (markers[id]) {
            markers[id].setMap(null);
        }
    }

    function showMarker(id: string, group = "default") {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        if (markers[id]) {
            markers[id].setMap(mapApi.map);
        }
    }

    function hideMarkersInGroup(group: string) {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        for (const id in markers) {
            markers[id].setMap(null);
        }
    }

    function showMarkersInGroup(group: string) {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        for (const id in markers) {
            markers[id].setMap(mapApi.map);
        }
    }

    // TODO: To add playback this might need to be updated to use a different marker type
    function addMarker({ id, lat, lng, image, label = null, group = "default", hidden = false, borderColor = null, size = {width: 16, height: 16} }: AddMarkerInterface) {
        if (!mapGroups[group]) mapGroups[group] = { markers: {}, lines: {} };
        const markers = mapGroups[group].markers;
        if (markers[id]) markers[id].setMap(null);
        const imageEl = document.createElement('img');
        imageEl.src = image;
        imageEl.style.width = `${size.width}px`;
        imageEl.style.height = `${size.height}px`;;
        if (borderColor){
            imageEl.style.borderRadius = "9999px"
            imageEl.style.border = `2px solid ${borderColor}`
            imageEl.style.objectFit = "cover"
        }
        
        markers[id] = new google.maps.marker.AdvancedMarkerElement({
            map: hidden ? null : mapApi.map,
            position: new google.maps.LatLng(lat, lng),
            content: imageEl
        });

        if (label) addHoverInfo(markers[id], label);
    }

    /**
     * Sets the position of a marker by its ID in the specified group.
     * Must be added first with `addMarker`.
    */
    function setMarkerPosition(id: string, lat: number, lng: number, group = "default") {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        if (markers[id]) markers[id].position = (new google.maps.LatLng(lat, lng));
    }

    function updateMarkerLabel(id: string, label: string, group = "default") {
        if (!mapGroups[group]) return;
        const markers = mapGroups[group].markers || {};
        if (markers[id]) addHoverInfo(markers[id], label);
    }

    function setStartMarkerPosition(lat: number, lng: number) {
        setMarkerPosition("start", lat, lng);
    }

    function setEndMarkerPosition(lat: number, lng: number) {
        setMarkerPosition("end", lat, lng);
    }

    function resetStartMarker() {
        setMarkerPosition("start", mapPolyline[0][0], mapPolyline[0][1]);
    }

    function resetEndMarker() {
        setMarkerPosition("end", mapPolyline[mapPolyline.length - 1][0], mapPolyline[mapPolyline.length - 1][1]);
    }

    function drawSectionLine(path: {lat: number, lng:number}[]) {
        removeSectionLine();
        mapGroups["default"]["lines"]["section"] = mapApi.drawPolyline({
            "path": path,
            "strokeColor": '#FF0000',
            "strokeOpacity": 0.8,
            "strokeWeight": 2
        });
        setStartMarkerPosition(path[0].lat, path[0].lng);
        setEndMarkerPosition(path[path.length-1].lat, path[path.length-1].lng);
    }

    function removeSectionLine() {
        if (mapGroups["default"]["lines"]["section"]) {
            mapGroups["default"]["lines"]["section"].setMap(null);
            delete mapGroups["default"]["lines"]["section"];
        }
        resetStartMarker();
        resetEndMarker();
    }

    function resetZoom() {
        if (!(mapApi && fullBounds)) return;
        mapApi.map.fitBounds(fullBounds);
    }

    function setCenterFromData(startIndex: number, endIndex: number, data: {lat: number, lng: number}[]) {  
        
        var bounds = new google.maps.LatLngBounds();
        for (var i = startIndex; i < endIndex; i++) {
            var p = data[i]; 
            if (p?.lat && p?.lng) {
                bounds.extend(new google.maps.LatLng(p.lat, p.lng));
            }
        }

        mapApi.map.fitBounds(bounds, null);
    }

    // TODO: 
    // drawLapLine

    function init() {

        const bounds = new google.maps.LatLngBounds();
        fullBounds = bounds;

        const sample = Math.ceil(mapPolyline.length / 100);
        for (let i = 0; i < mapPolyline.length; i++) {
            if (i % sample == 0)
                bounds.extend(new google.maps.LatLng(mapPolyline[i][0], mapPolyline[i][1]));
        }

        //@ts-expect-error
        mapApi = new window.GMaps({
            el: mapElement,
            scrollwheel: false,
            center: bounds.getCenter(),
            mapId: "7b6aa0bf344b0793",
            width: '---', // GMaps tries to assign a style tag, but if the parent is not rendered, it has size 0.
            height: '---', // Applying this invalid value just ignores this behaviour and uses our other stylesheets.
        });

        // TODO: Double check this works
        mapElement.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;
            if (target.tagName === 'BUTTON' && (target.getAttribute('aria-label') === 'Zoom in' || target.getAttribute('aria-label') === 'Zoom out')) {
            zoomOverride = true;
            }
        });
            
        mapApi.fitBounds(bounds);

        mapGroups["default"]["lines"]["main"] = mapApi.drawPolyline({
            "path": mapPolyline,
            "strokeColor": '#00B3FD',
            "strokeOpacity": 0.8,
            "strokeWeight": 4
        });
        addMarker({
            id: "start",
            lat: mapPolyline[0][0],
            lng: mapPolyline[0][1],
            image: iconStartMarker
        });
        addMarker({
            id: "end",
            lat: mapPolyline[mapPolyline.length - 1][0],
            lng: mapPolyline[mapPolyline.length - 1][1],
            image: iconEndMarker
        });
    }

    const ActivityMapController = {
        removeMarker,
        hideMarker,
        showMarker,
        hideMarkersInGroup,
        showMarkersInGroup,
        addMarker,
        setMarkerPosition,
        resetZoom,
        setStartMarkerPosition,
        setEndMarkerPosition,
        resetStartMarker,
        resetEndMarker,
        setCenterFromData,
        updateMarkerLabel,
        drawSectionLine,
        removeSectionLine,
    }

    // TODO: This is the rest of the Activity Map Controller which hasn't been implemented yet
    // setBoundsHeadingTilt: function(animateDuration, data, heading, tilt = 0, fixedZoom = null) {
    //     if (!ActivityMapController._map)
    //         return;

    //     let map = ActivityMapController._map;
    //     var bounds = new google.maps.LatLngBounds();
    //     for (const p of data) {
    //         if (p.lat && p.lng) {
    //             bounds.extend(new google.maps.LatLng(p.lat, p.lng));
    //         }
    //     }

    //     // adapted from map.fitBounds. fitBounds itself can't be used since it overrides heading.
    //     let getZoom = function (map, bounds, padding = 0) {
    //         const projection = map.getProjection();
    //         let mapDiv = map.getDiv();
            
    //         // use min dimension to fit, since points might be rotated with setHeading.
    //         let size = Math.min(mapDiv.clientWidth, mapDiv.clientHeight);
    //         // let width = mapDiv.clientWidth - padding;
    //         // let height = mapDiv.clientHeight - padding;
    //         let width = (size - padding);
    //         let height = width;

    //         let southWest = bounds.getSouthWest();
    //         let northEast = bounds.getNorthEast();
    //         const swLng = southWest.lng();
    //         if (swLng > northEast.lng()) 
    //             southWest = new google.maps.LatLng(southWest.lat(), swLng - 360, true);
    //         southWest = projection.fromLatLngToPoint(southWest);
    //         northEast = projection.fromLatLngToPoint(northEast);

    //         let x = Math.max(southWest.x, northEast.x) - Math.min(southWest.x, northEast.x);
    //         let y = Math.max(southWest.y, northEast.y) - Math.min(southWest.y, northEast.y);

    //         let length = Math.sqrt(x*x + y*y);
    //         if (length > width) return 0;
    //         return Math.log2(width + 1E-12) - Math.log2(length + 1E-12);

    //         //if (x > width || y > height) return 0;
    //         // return Math.min(
    //         //     Math.log2(width + 1e-12) - Math.log2(x + 1e-12),
    //         //     Math.log2(height + 1e-12) - Math.log2(y + 1e-12)
    //         // );
    //     };

    //     const padding = 50;
    //     const zoom = fixedZoom == null ? getZoom(map, bounds, padding) : fixedZoom;
    //     if (animateDuration) {
    //         map.setCenter(bounds.getCenter(), animateDuration);
    //         if (!this._zoomOverride) {
    //             map.setZoom(zoom);
    //             map.setTilt(tilt);
    //             map.setHeading(heading);
    //         }
    //     } else {
    //         if (this._zoomOverride) {
    //             map.moveCamera({
    //                 center: bounds.getCenter(),
    //             });
    //         } else {
    //             map.moveCamera({
    //                 center: bounds.getCenter(),
    //                 tilt: tilt,
    //                 heading: heading,
    //                 zoom: zoom
    //             });
    //             // map.setTilt(tilt);
    //             // map.setHeading(heading);
    //         }
    //     }
    // },

    // TODO: I don't think user lines are used anymore
    // _userLines: {},
    // clearUserLine: function(name) {
    //     let line = this._userLines[name];
    //     if (!line) return;
    //     delete this._userLines[name];
    //     line.route.setMap(null);
    //     line.startMarker.setMap(null);
    //     line.endMarker.setMap(null);
    // },
    // drawUserLine: function(name, data, startIndex, endIndex) {
    //     var map = ActivityMapController._map;
    //     if (!map) return;

    //     this.clearUserLine(name);

    //     var lap = [];
    //     if (!startIndex) {
    //         startIndex = 0;
    //         endIndex = data.length - 1;
    //     }
    //     for (let i = startIndex; i < endIndex; i++) {
    //         let p = data[i];
    //         if (p.lat && p.lng) lap.push({
    //             lat: p.lat,
    //             lng: p.lng
    //         });
    //     }
    //     if (lap.length == 0) return;
    //     this._userLines[name] = {
    //         route: map.drawPolyline({
    //             "path": lap,
    //             "strokeColor": '#00AAAA',
    //             "strokeOpacity": 0.8,
    //             "strokeWeight": 2
    //         }),
    //         startMarker: map.addMarker({
    //             lat: lap[0]['lat'],
    //             lng: lap[0]['lng'],
    //             icon: ActivityMapController._iconStartMarker
    //         }),
    //         endMarker: map.addMarker({
    //             lat: lap[lap.length - 1]['lat'],
    //             lng: lap[lap.length - 1]['lng'],
    //             icon: ActivityMapController._iconEndMarker
    //         })
    //     };
    // },

    // FOR BIND
    export let mapController: MapController = noopMapController
    
    const mountController = async () => {
        init()
        mapController = ActivityMapController
    }

    let isMounted = false
    let isLibLoaded = false
    onMount(() =>{
        isMounted = true
        if (isMounted && isLibLoaded) mountController()
    })
    const onLibLoad = () => {
        isLibLoaded = true
        if (isMounted && isLibLoaded) mountController()
    }

    const checkGmapsInWindow = () => {
        //@ts-expect-error
        return !window.GMaps
    }
</script>

<LibLoader url="/assets/global/plugins/gmaps/gmaps.min.js" on:loaded={onLibLoad} shouldLoadLib={checkGmapsInWindow}/>

<div bind:this={mapElement} class={cn("[&_img]:max-w-none w-full h-80", className)} />